import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import _get from 'lodash/get';

const FETCH_MONTHLY_PRODUCTIVITY = 'admins/FETCH_MONTHLY_PRODUCTIVITY';
const UPDATE_MONTHLY_PRODUCTIVITY = 'admins/UPDATE_MONTHLY_PRODUCTIVITY';

const TOGGLE_PROGRESS_BAR = 'admins/toggle-progress-bar';

const initialState = {
	productivityForm: {}
};

const actions = {
	fetchMonthlyProductivity: (id) => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.ADMINS_LIST}/${id}/monthly-productivity`,
			method: 'get',
			actions: [ FETCH_MONTHLY_PRODUCTIVITY ]
		});

		return request(dispatch);
	},
	updateMonthlyProductivity: (data, admin_id) => (dispatch, getState) => {
		const monthlyProductivity = data.monthlyProductivity
			.map(i => ({...i, admin_id, start: `${i.start}-01`, country_id: _get(i, 'country_id.0.value')}));
		dispatch({ type: TOGGLE_PROGRESS_BAR });

		const request = http({
			url: `${endpoints.ADMINS_LIST}/${admin_id}/monthly-productivity`,
			method: 'put',
			actions: [ UPDATE_MONTHLY_PRODUCTIVITY ],
			data: monthlyProductivity
		});

		return request(dispatch);
	}
};

const reducers = {
	[FETCH_MONTHLY_PRODUCTIVITY]: (state, action) => ({
		...state,
		showProgressBar: false,
		currentTab: 'monthly-productivity',
		productivityForm: { monthlyProductivity: action.payload.data }
	}),
	[UPDATE_MONTHLY_PRODUCTIVITY]: (state, action) => ({
		...state,
		currentTab: 'monthly-productivity',
		showProgressBar: false
	})
};

const selectors = {
	getMonthlyProductivityInitialData: state => {
		const tableData = { ...state.admins.productivityForm };

		if (tableData && tableData.monthlyProductivity && tableData.monthlyProductivity.length) {
			tableData.monthlyProductivity = tableData.monthlyProductivity
				.map(pr => ({...pr, country_id: [{ value: pr.country_id, label: pr.country_name }]}));
		}

		return tableData;
	}
};

export default function createProductivityForm() {
	return { actions, initialState, reducers, selectors };
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/monthly-productivity.index.js